module.exports = __webpack_public_path__ + "static/media/bg8.3d3c4499.jpg";